module.exports = __webpack_public_path__ + "img/cases-detail-1.2aa81265.png";